/*
 * Clock Canvas wishlist (clean port, 2026-06-08).
 * Self-contained, localStorage-based. Replaces the old custom_wishlist.js which
 * relied on jQuery + an external server (wilsons15.sg-host.com) + customer metafields.
 *
 * Behavior: clicking a `.wishlist_btn[data-product-handle]` toggles that product in
 * the wishlist and toggles the `.wishfill` class (CSS fills the heart red). State
 * persists in localStorage and re-applies on load. No count is shown.
 *
 * NOTE: full wishlist-page rendering + logged-in metafield sync is a later step; this
 * covers the add/remove + filled-heart interaction.
 */
(function () {
  var KEY = 'cc_wishlist';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function toggle(handle) {
    var arr = read();
    var i = arr.indexOf(handle);
    if (i === -1) { arr.push(handle); } else { arr.splice(i, 1); }
    write(arr);
    return i === -1; // true => now in the wishlist
  }

  function syncButton(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (handle && has(handle)) { btn.classList.add('wishfill'); }
    else { btn.classList.remove('wishfill'); }
  }

  // Header wishlist icon: show item count + fill the heart when the wishlist has items.
  function updateHeader() {
    var count = read().length;
    document.querySelectorAll('.header-wish-count').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
    document.querySelectorAll('.header__wishlist').forEach(function (el) {
      el.classList.toggle('wishfill', count > 0);
    });
  }

  // ---- Wishlist page rendering ----
  function money(cents) { return '$' + (Number(cents) / 100).toFixed(2); }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(p) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) { img = 'https:' + img; }
    var compare = (p.compare_at_price && p.compare_at_price > p.price)
      ? '<span class="cc-wish-compare">' + money(p.compare_at_price) + '</span>' : '';

    // Variant selector (only when more than one) + add-to-cart
    var variants = p.variants || [];
    var firstAvail = null;
    for (var i = 0; i < variants.length; i++) { if (variants[i].available && !firstAvail) { firstAvail = variants[i]; } }
    var opts = '';
    if (variants.length > 1) {
      opts = '<select class="cc-wish-variant" aria-label="Choose option">';
      for (var j = 0; j < variants.length; j++) {
        var v = variants[j];
        var sel = (firstAvail && v.id === firstAvail.id) ? ' selected' : '';
        opts += '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + sel + '>' +
          escapeHtml(v.title) + (v.available ? '' : ' — Sold out') + '</option>';
      }
      opts += '</select>';
    }
    var atcId = firstAvail ? firstAvail.id : (variants[0] ? variants[0].id : '');
    var soldOut = !firstAvail;
    var atc = '<button type="button" class="cc-wish-atc" data-variant-id="' + atcId + '"' +
      (soldOut ? ' disabled' : '') + '>' + (soldOut ? 'Sold out' : 'Add to cart') + '</button>';

    return '<div class="cc-wish-card-wrap">' +
      '<a href="' + p.url + '" class="cc-wish-card">' +
        (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
        '<div class="cc-wish-title">' + escapeHtml(p.title) + '</div>' +
        '<div class="cc-wish-price">' + money(p.price) + compare + '</div>' +
      '</a>' +
      '<div class="cc-wish-actions">' + opts + atc + '</div>' +
      '<button type="button" class="cc-wish-remove" data-handle="' + escapeHtml(p.handle) + '" aria-label="Remove from wishlist">&times;</button>' +
    '</div>';
  }

  // Update the header cart count/dot after an add (raw /cart/add.js doesn't auto-refresh it)
  function refreshCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('cart-count').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('.header__cart-dot').forEach(function (el) {
        if (cart.item_count > 0) { el.classList.add('is-visible'); }
      });
    }).catch(function () {});
  }

  function renderWishlistPage() {
    var grid = document.getElementById('ccWishlistGrid');
    if (!grid) return;
    var empty = document.getElementById('ccWishlistEmpty');
    var handles = read();
    grid.innerHTML = '';
    if (!handles.length) { if (empty) empty.style.display = 'block'; return; }
    if (empty) empty.style.display = 'none';
    handles.forEach(function (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) { if (p) grid.insertAdjacentHTML('beforeend', cardHTML(p)); })
        .catch(function () {});
    });
  }

  function bind(btn) {
    if (btn.dataset.ccWishBound) return;
    btn.dataset.ccWishBound = '1';
    syncButton(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      var added = toggle(handle);
      btn.classList.toggle('wishfill', added);
      updateHeader();
    });
  }

  function init() {
    document.querySelectorAll('.wishlist_btn[data-product-handle]').forEach(bind);
    updateHeader();
    renderWishlistPage();
  }

  // Remove button on the wishlist page (delegated)
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('.cc-wish-remove');
    if (!rm) return;
    e.preventDefault();
    var handle = rm.getAttribute('data-handle');
    if (!handle) return;
    var arr = read();
    var i = arr.indexOf(handle);
    if (i !== -1) { arr.splice(i, 1); write(arr); }
    updateHeader();
    renderWishlistPage();
    document.querySelectorAll('.wishlist_btn[data-product-handle="' + handle + '"]').forEach(function (b) { b.classList.remove('wishfill'); });
  });

  // Add-to-cart on the wishlist page (delegated)
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('.cc-wish-atc');
    if (!atc || atc.disabled) return;
    e.preventDefault();
    var wrap = atc.closest('.cc-wish-card-wrap');
    var select = wrap ? wrap.querySelector('.cc-wish-variant') : null;
    var variantId = select ? select.value : atc.getAttribute('data-variant-id');
    if (!variantId) return;
    var orig = atc.textContent;
    atc.disabled = true;
    atc.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        atc.textContent = 'Added ✓';
        refreshCartCount();
        // Refresh the cart drawer's contents and slide it out so the add is visible
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          setTimeout(function () { drawer.show(); }, 150);
        }
        setTimeout(function () { atc.textContent = orig; atc.disabled = false; }, 1600);
      })
      .catch(function () { atc.textContent = orig; atc.disabled = false; });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Re-bind after AJAX section re-renders (e.g. variant change re-rendering the gallery)
  document.addEventListener('shopify:section:load', init);
})();
